<template>
  <div>
    <div v-if="actionObject.style==='free'">
      <img class="card__icon" src="@/assets/pi.svg" v-if="actionObject.topic==='math'">
      <img class="card__icon" src="@/assets/sport.svg" v-if="actionObject.topic==='sport'">
      <img class="card__icon" src="@/assets/energy.svg" v-if="actionObject.topic==='sleep'">
      <img class="card__icon" src="@/assets/cheese.svg" v-if="actionObject.topic==='french'">
      <img class="card__icon" src="@/assets/game.svg" v-if="actionObject.topic==='gaming'">
    </div>
    <div v-if="actionObject.style==='exam'">
      <img class="card__icon" src="@/assets/exam-math.png" v-if="actionObject.topic==='math'">
      <img class="card__icon" src="@/assets/exam-sport.png" v-if="actionObject.topic==='sport'">
      <img class="card__icon" src="@/assets/exam-french.png" v-if="actionObject.topic==='french'">
    </div>
    <span class="card__label">{{description}}</span>
  </div>
</template>

<script>

export default {
  name: "ActionIcon",
  props: {
    actionObject: Object,
  },
  data() {
    return {};
  },

  computed: {
    description() {
      switch(this.action) {
        case "math":
          return "Study Math";
        case "french":
          return "Study French";
        case "sport":
          return "Work out";
        case "gaming":
          return "Play video game";
        case "sleep":
          return "Sleep";
        case "chill":
          return "";
      }
      return "";
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.card__icon {
  position: absolute;
  top: 25%;
  left: 5%;
  max-width: 10vw;
  max-height: 10vw;
}
</style>
